<template>
  <img
    v-if="displayLogo"
    :src="imgSrc"
    :style="{ opacity: hideLogo ? 0 : 1 }"
    :class="[classes.promoLogo, 'promo-logo']"
    @load="handleLoad"
    @error="displayLogo = false"
  />
  <MarketName
    v-else
    :class="[classes.marketName, 'promo-market-name']"
    :fallbackName="marketName"
  ></MarketName>
</template>

<script>
import { useLayoutEffect } from "@fresh8/vue-utils/src/dimensionSync";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { computed, ref, defineComponent } from "vue";
import {
  injectAdTag,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import Color from "color";
import MarketName from "../../MarketName.vue";

const { useStyles } = createUseStyles(
  {
    marketName: {
      display: "flex",
      alignItems: "center",
      "&.promo-market-name": {
        fontSize: "16px",
        textAlign: "center"
      }
    },
    promoLogo: {
      maxWidth: "150px"
    }
  },
  undefined
);

export default defineComponent({
  name: "PromoLogo",
  components: {
    MarketName
  },
  props: {
    promoMarketName: { type: String, required: true },
    marketName: { type: String, required: true }
  },
  setup(props) {
    const { adTemplateBranding } = injectBrand();
    const { classesRef } = useStyles(ref(undefined));
    const effectTrigger = useLayoutEffect();
    const { operator } = injectAdTag();
    const displayLogo = ref(true);
    const hideLogo = ref(true);

    const imageShade = computed(() => {
      const backgroundColorAsColor = Color(
        adTemplateBranding.value.backgroundColor
      );
      if (backgroundColorAsColor.valpha < 0.5) {
        return "dark";
      }
      return backgroundColorAsColor.isLight() ? "dark" : "light";
    });

    const imgSrc = computed(() => {
      return `https://cdn.fresh8.co/assets/evo-assets/market-logos/${operator.value.key}/${props.promoMarketName}/${imageShade.value}.svg?v=20210203121538`;
    });

    const handleLoad = () => {
      effectTrigger();
      hideLogo.value = false;
    };

    return {
      classes: classesRef,
      imgSrc,
      effectTrigger,
      displayLogo,
      hideLogo,
      handleLoad
    };
  }
});
</script>

<style></style>
